import { useRouter } from "next/router";
import { Page as Component } from "~/components/specifics/403/Page";

export function Page() {
	const router = useRouter();
	const { message } = router.query;
	return <Component message={String(message || "")} />;
}
